// extracted by mini-css-extract-plugin
module.exports = {"bottom_affix":"bottom_affix-2-D75ePg","toTop_affix":"toTop_affix-1B1BD-8k","backToTop":"backToTop-p7_zgdMg"};